$(function(){
  if (window.__relatedProductsHasFired) {
    return;
  }

  window.Branch = window.Branch || {};
  window.Branch.relatedProducts = window.Branch.relatedProducts || {};
  window.Branch.relatedProducts.sliders = window.Branch.relatedProducts.sliders || {};
  window.__relatedProductsHasFired = true;

  const initRelatedProductsSlider = function(relatedProductsSection, parent){
    if (typeof window.Swiper === 'undefined') {
      if (typeof window.whenSwiperReady === 'function') {
        window.whenSwiperReady(function(){ initRelatedProductsSlider(relatedProductsSection, parent); });
      }
      return;
    }
    let styling = relatedProductsSection.getAttribute('data-styling');
    let parentId = parent.getAttribute('id');
    let params;
    if(styling == 'homepage'){
      params = {
        slidesPerView: 1.25,
        spaceBetween: 30,
        navigation: {
            nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
            prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
        },
        breakpoints: {
            600: {
              slidesPerView: 2.25,
              spaceBetween: 40,
              navigation: {
                nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
                prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
              }
            },
            1024: {
              slidesPerView: 3.25,
              spaceBetween: 40,
              navigation: {
                nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
                prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
              }
            }
          },
          on: {
            init: window.Branch.functions.checkSwiperNavVisibility,
            resize: window.Branch.functions.checkSwiperNavVisibility,
          }
      }
    } else {
      params = {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
            prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
        },
        breakpoints: {
            600: {
              slidesPerView: 2,
              spaceBetween: 20,
              navigation: {
                nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
                prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
              }
            },
            840: {
              slidesPerView: 3,
              spaceBetween: 20,
              navigation: {
                nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
                prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
              }
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
              navigation: {
                nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
                prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
              }
            }
          }
          
      }
    }
    
    
    window.Branch.relatedProducts.sliders[`${parentId}`] = new Swiper(`#${parentId} .related-products.page-container .related-products__product-carousel-container`, params);
    };

    const setSrcSetAndFallback = function(img, srcSet){
      if(!img) return;
      img.setAttribute('srcset', srcSet);
      let fallback = srcSet.split(',').map(s => s.trim()).find(s => s.endsWith(' 540w'));
      if(fallback) img.setAttribute('src', fallback.split(' ')[0]);
    }

    const updateImageSrcSet = function(cloneDiv, cookieDescriptionStringArray, styling){
      let baseUrl = `//www.branchfurniture.com/cdn/shop/`;
      if(window.location.href.indexOf("branchfurniture.ca") > -1){baseUrl = `//www.branchfurniture.ca/cdn/shop/`}
      let cookieProductImageUrl =  `${baseUrl}${cookieDescriptionStringArray[1].trim()}`;
      let cookieProductHoverImageUrl = `${baseUrl}${cookieDescriptionStringArray[1].trim()}`;
      let srcSet = window.Branch.functions.returnSrcSet(cookieProductImageUrl);
      let hoverSrcSet = window.Branch.functions.returnSrcSet(cookieProductImageUrl);

        if(cookieDescriptionStringArray[8]){
          cookieProductHoverImageUrl = `${baseUrl}${cookieDescriptionStringArray[8].trim()}`;
          hoverSrcSet = window.Branch.functions.returnSrcSet(cookieProductHoverImageUrl);
        }

       if(styling == 'homepage'){
        let tempSrcSet = srcSet
        srcSet = hoverSrcSet;
        hoverSrcSet = tempSrcSet;
       } 

      let imageType = cookieDescriptionStringArray[14] == 'true' ? 'composite' : cookieDescriptionStringArray[11] == 'true' ? 'pre-set-bundle' : 'regular';

      if(imageType !== 'regular'){
        let originalImg = cloneDiv.querySelector('.product-image-container img');
        if(styling == 'homepage'){
          originalImg = cloneDiv.querySelector('.product-image-hover__image')
        }

        // Build the images to stack, back to front. The overlays are absolutely positioned
        // with no z-index, so DOM order is paint order: a composite's second layer sits
        // behind its first, matching buildCompositeLayersHTML.
        let layerPaths = [];
        const pushLayerPair = (firstPath, secondPath) => { layerPaths.push(secondPath, firstPath); };

        if(imageType == 'composite'){
          pushLayerPair(cookieDescriptionStringArray[15].trim(), cookieDescriptionStringArray[16].trim());
        } else {
          // One slot per bundle constituent: [12] = product 1, [13] = product 2. A slot holding
          // "<first>###<second>" is a composite constituent and expands to its two layers.
          [cookieDescriptionStringArray[12], cookieDescriptionStringArray[13]].forEach((slot) => {
            let slotPaths = (slot || '').trim().split('###').filter(Boolean);
            if(slotPaths.length == 2){
              pushLayerPair(slotPaths[0], slotPaths[1]);
            } else if(slotPaths.length == 1){
              layerPaths.push(slotPaths[0]);
            }
          });
        }

        // The clone still carries the source tile's src; point it at this layer too, so the
        // fallback matches the srcset rather than showing the product we cloned from.
        const applyLayer = (img, path) => {
          let layerSrcSet = window.Branch.functions.returnSrcSet(`${baseUrl}${path}`);
          img.setAttribute('srcset', layerSrcSet);
          let fallback = layerSrcSet.split(',').map(s => s.trim()).find(s => s.endsWith(' 540w'));
          if(fallback) img.setAttribute('src', fallback.split(' ')[0]);
        };

        originalImg.classList = 'pre-set-bundle-image__product-overlay';
        if(layerPaths.length == 0){
          // Nothing usable in the cookie — leave the tile on the product image.
          originalImg.setAttribute('srcset', srcSet);
        } else {
          applyLayer(originalImg, layerPaths[0]);
          let previousImg = originalImg;
          for(let layerIndex = 1; layerIndex < layerPaths.length; layerIndex++){
            let clonedImg = originalImg.cloneNode(true);
            applyLayer(clonedImg, layerPaths[layerIndex]);
            previousImg.parentNode.insertBefore(clonedImg, previousImg.nextSibling);
            previousImg = clonedImg;
          }
        }
        originalImg.parentNode.classList += ' pre-set-bundle-image-container'
      } else {
        setSrcSetAndFallback(cloneDiv.querySelector('.product-image-container img'), srcSet);
      }
      if(cookieDescriptionStringArray[11] == 'true' && styling == 'homepage'){
        setSrcSetAndFallback(cloneDiv.querySelector('.product-image-container img'), srcSet);
      } else {
      cloneDiv.querySelectorAll('.product-tile__image-container .product-image-hover img').forEach((hoverImage) => {
        setSrcSetAndFallback(hoverImage, hoverSrcSet);
      })
      }
    }

    const updatePrice = function(cloneDiv, cookieDescriptionStringArray){
      let cookieProductPrice = cookieDescriptionStringArray[2].trim();
      let cookieProductPriceVaries = cookieDescriptionStringArray[3].trim();
      let cookieOriginalProductPrice = cookieDescriptionStringArray[10] ? cookieDescriptionStringArray[10].trim() : cookieProductPrice;


      if(cloneDiv.querySelector('.product-tile__info-container .from')){
        cloneDiv.querySelector('.product-tile__info-container .from').remove();
      }

      const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(cookieProductPrice, cookieOriginalProductPrice, 0, '', cookieDescriptionStringArray[0].trim());
      cookieProductPrice = codeDiscountData.currentPrice

      
      let priceHtml = `${Shopify.formatMoney((Math.ceil(cookieProductPrice/100)*100), Simplistic.formatMoney).replace('.00', '').replace(' ','')}`;
      let originalPriceHtml = cookieOriginalProductPrice == "" || cookieOriginalProductPrice == "0" ? null : `${Shopify.formatMoney((Math.ceil(cookieOriginalProductPrice/100)*100), Simplistic.formatMoney).replace('.00', '').replace(' ','')}`;
      if(cookieProductPriceVaries == "t"){
        priceHtml = `${priceHtml}+`
      }

      cloneDiv.querySelector('.price .deal span[data-price="deal"]').innerHTML = priceHtml;
      if(originalPriceHtml != null && cookieProductPrice < cookieOriginalProductPrice){
        cloneDiv.querySelector('.price .retail span[data-price="retail"]').innerHTML = originalPriceHtml;
        cloneDiv.querySelector('.price .retail').setAttribute('data-visible', "true")
      } else {
        cloneDiv.querySelector('.price .retail span[data-price="retail"]').innerHTML = '';
        cloneDiv.querySelector('.price .retail').setAttribute('data-visible', "false")
      }
    }

    const updateSalesText = function(cloneDiv, cookieDescriptionStringArray, parent){
      let productStillDiscounted = false;
      let cookieProductSaleText = cookieDescriptionStringArray[6].trim().replaceAll('*', ' ');
      let discountIndex;
      if(cookieProductSaleText.includes('#') == false){
        productStillDiscounted = true;
      } else {
        discountIndex = parseInt(cookieProductSaleText.split('#')[1])
      }
      if(discountIndex > 0){
        let productHandleData = JSON.parse(document.querySelector(`#${parent.getAttribute('id')} #discount-code-data`).innerText);
        let handles = productHandleData[`discount_code_${discountIndex}_product_handles`];
        if(handles){
          let handlesArray = handles.replaceAll(' ', '').split(',');
          handlesArray.forEach((handle) => {
            if(handle == cookieDescriptionStringArray[0].trim()){
              productStillDiscounted = true;
            }
          })
        }
      }

      if(productStillDiscounted == false) {
        let cookieOriginalProductPrice = cookieDescriptionStringArray[10].trim();
        if(cookieOriginalProductPrice != "" || cookieOriginalProductPrice != "0"){
          cookieDescriptionStringArray[2] = cookieDescriptionStringArray[10];
          cookieDescriptionStringArray[10] = "0";
        }
      }

      let promoProduct = false
      let promoHandles = document.querySelector(`#${parent.getAttribute('id')} #related-products-promo-handles`) ? JSON.parse(document.querySelector(`#${parent.getAttribute('id')} #related-products-promo-handles`).innerText) : undefined;
      if(promoHandles && promoHandles.handles && promoHandles.handles.length > 0){
        promoHandles.handles.forEach((promoHandle) => {
          if(promoHandle == cookieDescriptionStringArray[0].trim()){
            promoProduct = true; 
          }
        })
      }

      if(cloneDiv.querySelector('.sale')){
        cloneDiv.querySelector('.sale').remove();
      }

      let codeDiscountMessage = window.Branch.functions.returnSalesTagText(cookieDescriptionStringArray[0].trim(), 'fromHandle', 'sale-swatch');
      if(cookieDescriptionStringArray[11] == 'true'){
        let cookieProductPrice = cookieDescriptionStringArray[2].trim();
        let cookieOriginalProductPrice = cookieDescriptionStringArray[10] ? cookieDescriptionStringArray[10].trim() : cookieProductPrice;
        let discountPercentage = Math.round(
          ((cookieOriginalProductPrice - cookieProductPrice) / cookieOriginalProductPrice) * 100
        );
        
        codeDiscountMessage = `Save ${discountPercentage}%`;
      }

      let displaySwatch = cookieProductSaleText !== '' && cookieProductSaleText !== 'n' && productStillDiscounted == true ? true : codeDiscountMessage != "" ? true : false;
      let specialSwatchColor = window.Branch.functions.returnSpecificActiveCampaignData(cookieDescriptionStringArray[0].trim(), 'fromHandle', 'swatch-color');
      // OR-in the personalization: when it's the promo-styling winner on this page, related-products
      // swatches get the gradient even if the campaign's own promo styling is off. See personalizations_trigger.liquid.
      let campaignPromoStylingEnabled = window.Branch.functions.returnSpecificActiveCampaignData(cookieDescriptionStringArray[0].trim(), 'fromHandle', 'promo-styling') || (window.Branch.personalization && window.Branch.personalization.promoStylingWins);

      if(displaySwatch){
        let salesSwatchHtml = `<div data-display="true" ${promoProduct == true ? 'promo-style="true" promo-style-on-hover="true"': ''} ${campaignPromoStylingEnabled ? ' active-campaign-promo-style="true" active-campaign-promo-type="discount_swatches" ' : ''} ${specialSwatchColor ? ' data-display-active-campaign-swatch-background="true" ' : ''} data-sale-text="${cookieProductSaleText}" class="sale"><span>${codeDiscountMessage != "" ? codeDiscountMessage : cookieProductSaleText.split('#')[0]}</span></div>`
        cloneDiv.querySelector('.product-image').insertAdjacentHTML('beforeend', salesSwatchHtml);
      }
    }

    const updateTileData = function(cloneDiv, cookieDescriptionStringArray, cookieProductHandle){
      // console.log('cookieDescriptionStringArray', cookieDescriptionStringArray)
      let cookieProductUrl = cookieDescriptionStringArray[4].trim();
      let cookieProductTitle = cookieDescriptionStringArray[5].trim().replaceAll('*', ' ');
      let cookieVariantTitle = cookieDescriptionStringArray[7].trim().replaceAll('*', ' ');
      let cookieColorCombos = cookieDescriptionStringArray[9].trim().replaceAll('*', ' ');

      cloneDiv.querySelector('a').setAttribute('href',`/products/${cookieProductHandle}`);
      cloneDiv.querySelector('.title').innerHTML = `${cookieProductTitle}`;
      cloneDiv.querySelector('.product-tile__image-container .product-image').setAttribute('data-title', cookieProductTitle);
      cloneDiv.querySelector('.product-tile__image-container .product-image').setAttribute('data-variant', cookieVariantTitle);
      cloneDiv.querySelector('.product-tile__image-container .product-image').removeAttribute('data-variant-id');
      cloneDiv.setAttribute('data-id', Math.floor(1000 + Math.random() * 9000));


      if(cloneDiv.querySelector('.product-available-colors')){
        cloneDiv.querySelector('.product-available-colors').innerHTML = `${cookieColorCombos}`;
      }
    }

    const insertNewSlide = function(cookieDescriptionStringArray, cookieProductHandle, newProductHandles, slidesReplaced, productAlreadyInList, relatedProductsSection, parent, styling) {
      let slides = document.querySelectorAll(`#${parent.getAttribute('id')} .related-products__product-carousel .product-tile`);
    
      if (slides.length === 0) return;
    
      const firstSlide = slides[slidesReplaced - 1];
      const cloneDiv = firstSlide.cloneNode(true);

      // If the source tile is a composite product, updateStaticTile has already
      // appended a .product-tile-composite-wrapper and hidden the underlying <img>.
      // We are re-skinning this clone for a different product, so drop that stale
      // wrapper (otherwise it stacks below pre-set-bundle-image-container and the
      // tile renders at 2x height) and unhide the <img> so our srcset swap shows.
      cloneDiv.querySelectorAll('.product-tile-composite-wrapper').forEach(w => w.remove());
      cloneDiv.querySelectorAll('img[data-hidden-for-composite="true"]').forEach(im => {
        im.removeAttribute('data-hidden-for-composite');
        im.style.display = '';
      });
      window.Branch.compositeRenderImage?.restoreNonInvolvedTileImages?.(cloneDiv);

      let lastSlide = slides[slides.length - 1];
    
      if (productAlreadyInList) {
        let existingSlide = document.querySelector(`#${parent.getAttribute('id')} .related-products__product-carousel .product-tile a[href="/products/${cookieProductHandle}"]`);
        if (existingSlide) {
          lastSlide = existingSlide.closest('.product-tile');
        }
      }
    
      updateImageSrcSet(cloneDiv, cookieDescriptionStringArray, styling);
      updateSalesText(cloneDiv, cookieDescriptionStringArray, parent);
      updatePrice(cloneDiv, cookieDescriptionStringArray);
      updateTileData(cloneDiv, cookieDescriptionStringArray, cookieProductHandle);
    
      document.querySelector(`#${parent.getAttribute('id')} .related-products__product-carousel`).insertBefore(cloneDiv, firstSlide);
      lastSlide.remove();
      newProductHandles.push(cookieProductHandle);
    }

    const selectQualifyingRecentlyViewedProducts = function(cookieArray, relatedProductsSection, parent, styling){
      let existingHandles = document.querySelector(`#${parent.getAttribute('id')} .related-products.page-container`).getAttribute('data-product-handles').split(',');
      let currentProductHandle = document.querySelector(`#${parent.getAttribute('id')} .related-products.page-container`).getAttribute('data-current-product-handle');
      let newProductHandles = [];
      let slidesReplaced = 0;

      cookieArray.forEach((cookieDescriptionString) => {
        if(cookieDescriptionString != "" ){
          let cookieDescriptionStringArray = cookieDescriptionString.split('@@');
          let cookieProductHandle = cookieDescriptionStringArray[0].trim();
          if(!newProductHandles.includes(cookieProductHandle) && cookieProductHandle !== currentProductHandle){
            slidesReplaced = slidesReplaced + 1;
            if(slidesReplaced < 4){
              insertNewSlide(cookieDescriptionStringArray, cookieProductHandle, newProductHandles, slidesReplaced, existingHandles.includes(cookieProductHandle), relatedProductsSection, parent, styling); 
            }
          } 
        }
      })
    }

    const updateSliderAriaLabels = function(relatedProductsSection, parent){
      let updatedSlides = document.querySelectorAll(`#${parent.getAttribute('id')} .related-products__product-carousel .product-tile`);
      let cascadeIndex = 0;
      if(updatedSlides){
        cascadeIndex = parseInt(updatedSlides[0].getAttribute('data-cascade-order'));
      }
      
          updatedSlides.forEach((updatedSlide, index) => {
          updatedSlide.setAttribute('aria-label', `${index + 1} / ${updatedSlides.length}`);
          if(updatedSlides[updatedSlides.length - 1].getAttribute('data-animated') != 'true'){
            updatedSlide.setAttribute('data-cascade-order', `${cascadeIndex}`);

            const width = window.innerWidth;

            if (
                (width < 840 && index < 1) ||
                (width < 1024 && index < 2) ||
                (width >= 1024 && index < 3)
            ) {
                cascadeIndex++;
            }
          }
      });
      

    }

    const retrieveRecentlyViewProducts = function(relatedProductsSection, parent, styling){
      if(document.cookie.split("; ").find((row) => row.startsWith("shopify_recently_viewed_data="))){
        const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("shopify_recently_viewed_data="))
        ?.split("=")[1];

        let cookieString = decodeURIComponent(cookieValue).trim();
        let cookieArray = cookieString.split('|||'); 

        if(cookieArray.length > 0){
          selectQualifyingRecentlyViewedProducts(cookieArray, relatedProductsSection, parent, styling);
          updateSliderAriaLabels(relatedProductsSection, parent);
        }
      }
    }

    const updatePricingForCart = function(relatedProductsSection){
      relatedProductsSection.querySelectorAll('.product-tile .price').forEach((price) => {
        let handle = price.getAttribute('data-product-handle');
        let priceData = document.querySelector(`.per-variant-pricing[data-product-handle="${handle}"]`) ? JSON.parse(document.querySelector(`.per-variant-pricing[data-product-handle="${handle}"]`).innerText) : {};
        let productTile = price.closest('.product-tile');
        let variantId = parseInt(productTile.getAttribute('data-variant-id'))
        let tileType = 'regular';
        window.Branch.collection.updateDisabledSwatchedPrice(productTile, priceData, tileType, handle, variantId);
      }) 
    }

    const initToolTips = function(relatedProductsSection) {
      relatedProductsSection.querySelectorAll('.related-products__ux-toggle-container').forEach(wrapper => {
        const button = wrapper.querySelector('.related-products__ux-toggle');
        const tooltip = wrapper.querySelector('.related-products__ux-toggle-tooltip');
        if (window.Branch.functions.isTouchDevice()) {
          let isVisible = false;
      
          button.addEventListener('click', (e) => {
            e.stopPropagation();
            isVisible = !isVisible;
            tooltip.setAttribute('data-visible', isVisible);
          });
      
          tooltip.addEventListener('click', (e) => {
            e.stopPropagation();
          });
      
          document.body.addEventListener('click', () => {
            isVisible = false;
            tooltip.setAttribute('data-visible', false);
          });
        } else {
          let hideTimeout;
          wrapper.addEventListener('mouseenter', () => {
            clearTimeout(hideTimeout);
            tooltip.setAttribute('data-visible', true);
          });
          
          wrapper.addEventListener('mouseleave', () => {
            hideTimeout = setTimeout(() => {
              tooltip.setAttribute('data-visible', false);
            }, 250);
          });
          
          tooltip.addEventListener('mouseenter', () => {
            clearTimeout(hideTimeout);
          });
          
          tooltip.addEventListener('mouseleave', () => {
            tooltip.setAttribute('data-visible', true);
          });

        }
      
        wrapper.querySelector('.related-products__ux-toggle-tooltip-link').addEventListener('click', (e) => {
          e.preventDefault();
          const targetToggle = document.querySelector('.toggle-header-title-bar-container__toggle-dtc-element');

          window.scrollTo({ top: 0, behavior: 'smooth' });

          let lastPosition = window.scrollY;
          let checkCount = 0;
          const maxChecks = 30;

          const waitForScrollEnd = () => {
            const currentPosition = window.scrollY;

            if (currentPosition === 0 || checkCount > maxChecks) {
              if (targetToggle) {
                setTimeout(function(){
                  targetToggle.click();
                }, 1500)
              }
              return;
            }

            checkCount++;
            setTimeout(waitForScrollEnd, 100);
          };

          waitForScrollEnd();
          
        });
      });
      
    }

   
    const initQuizCheckoutATC = function(relatedProductsSection){
      relatedProductsSection.addEventListener('click', function(event) {
        const target = event.target.closest('.related-products__cta');
        console.log()
        if (!target) return;
        const isQuizCheckout = target.getAttribute('data-quiz-checkout') === 'true';
      
        if (isQuizCheckout) {
          event.preventDefault();
          const ids = target.getAttribute('data-quiz-checkout-ids').split(',');
          if(ids.length > 0){
            $('#loading-overlay').show();
          
          console.log('ids', ids);
          const items = ids.map(id => ({
            id,
            quantity: 1,
            properties: {
              _ship_date: document.querySelector(`.msbd-message__input[data-variant-id="${id}"]`).value
            }
          }));
        
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Failed to add to cart');
            }
            return response.json();
          })
          .then(data => {
            console.log('Added items:', data);
            $('#loading-overlay').hide();
            window.Branch.cart.updateCartDesc(true);
            target.innerHTML = 'Checkout';
            target.removeAttribute('data-quiz-checkout');
            target.setAttribute('href', '/checkout');
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
          });
        }
      }
      });
      
    }

    const initRelatedProducts = function(relatedProductsSection, parent){
      console.log('initRelatedProducts')
      initRelatedProductsSlider(relatedProductsSection, parent); 
      if(relatedProductsSection.getAttribute('data-type') == "cart" || relatedProductsSection.getAttribute('data-type') == "quiz"){
        updatePricingForCart(relatedProductsSection)
      }

      if(relatedProductsSection.getAttribute('data-type') == "quiz"){
        initQuizCheckoutATC(relatedProductsSection);
      }

      initToolTips(relatedProductsSection);

      // When a personalization override locks this section (homepage special products), never switch to
      // the "browsed"/recently-viewed view — the override content must always show.
      if(relatedProductsSection.getAttribute('data-personalization-locked') != "true" && relatedProductsSection.getAttribute('data-recently-viewed') == "true" && relatedProductsSection.getAttribute('data-type') != "cart" && relatedProductsSection.getAttribute('data-type') != "quiz"){
        let styling = relatedProductsSection.getAttribute('data-styling');
        retrieveRecentlyViewProducts(relatedProductsSection, parent, styling);
        relatedProductsSection.setAttribute('data-type', 'browsed');
        relatedProductsSection.querySelectorAll('.related-products__title-subtitle-container:not([data-type="browsed"]), .related-products__cta:not([data-type="browsed"])').forEach((titleSubtitleContainer) => {titleSubtitleContainer.setAttribute('aria-hidden', true)})
        relatedProductsSection.querySelectorAll('.related-products__title-subtitle-container[data-type="browsed"], .related-products__cta:not([data-type="browsed"])').forEach((titleSubtitleContainer) => {titleSubtitleContainer.setAttribute('aria-hidden', false)})
      }
    }

    window.Branch.relatedProducts.relatedProductsInitOnLoad = function(){
      let relatedProductsSections = document.querySelectorAll('.related-products:not([data-initialized="true"])');
      relatedProductsSections.forEach((relatedProductsSection) => {
          let parent = relatedProductsSection.closest('.shopify-section');
          relatedProductsSection.setAttribute('data-initialized', true);
          initRelatedProducts(relatedProductsSection, parent);
      })  
  }

  if (document.readyState === "complete") {
      window.Branch.relatedProducts.relatedProductsInitOnLoad(); 
  } else {
      window.addEventListener("load", window.Branch.relatedProducts.relatedProductsInitOnLoad);
  }
});
